import React from 'react';
export function Process() {
  const steps = [{
    num: '01',
    icon: '💬',
    title: 'Contactanos por WhatsApp',
    desc: 'Contanos tu idea, el tamaño que buscás y para qué espacio es. En menos de 24hs te respondemos.'
  }, {
    num: '02',
    icon: '✏️',
    title: 'Diseño Personalizado',
    desc: 'Te mandamos un diseño digital para que veas cómo va a quedar antes de que lo produzcamos. Incluís cambios sin cargo.'
  }, {
    num: '03',
    icon: '🔨',
    title: 'Producción Artesanal',
    desc: 'Fabricamos tu cuadro a mano con materiales de calidad. Cada pieza es revisada antes de embalarse.'
  }, {
    num: '04',
    icon: '📦',
    title: 'Envío a Todo el País',
    desc: 'Lo empacamos con triple protección y lo enviamos por correo. Recibís el tracking para seguir tu pedido.'
  }];
  return <section id="proceso" className="py-[100px] px-[5%] relative z-10 bg-[#0a0a0a] border-y border-dark-border" data-id="element-53">
      <div className="text-[0.7rem] tracking-[4px] uppercase text-neon-pink mb-3" data-id="element-54">
        — Cómo Funciona
      </div>
      <h2 className="font-bebas text-[clamp(2.2rem,5vw,4rem)] leading-none mb-4" data-id="element-55">
        4 PASOS PARA
        <br data-id="element-56" />
        TU CUADRO
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[1px] bg-dark-border border border-dark-border mt-[60px]" data-id="element-57">
        {steps.map(step => <div key={step.num} className="bg-[#0a0a0a] p-10 relative group" data-id="element-58">
            <div className="font-bebas text-6xl text-dark-border leading-none mb-5 transition-colors duration-300 group-hover:text-neon-pink" data-id="element-59">
              {step.num}
            </div>
            <div className="text-[1.8rem] mb-4" data-id="element-60">{step.icon}</div>
            <div className="font-bold text-base mb-2.5 tracking-[0.5px]" data-id="element-61">
              {step.title}
            </div>
            <p className="text-[0.82rem] text-text-muted leading-[1.6]" data-id="element-62">
              {step.desc}
            </p>
          </div>)}
      </div>
    </section>;
}